import React, { useEffect } from 'react';
import LazyLoad from 'react-lazyload';
import styled from 'styled-components';
import { useGO } from '../../hooks/useGO';

import { media } from '../../utils/styles';
import { Container, Heading2 } from '../common';
import { VideoController } from './VideoController';
import { VisibilityChecker } from '../VisibilityChecker';
import { log } from '../../utils/logs';

export const VideoEngagement = ({ videoUrl, cover, heading }) => {
  const showVideo = useGO('6dRgARq4QpOBIrATjopFmA', 'videoEngagement', [false, true]);

  useEffect(() => {
    if (showVideo) {
      log('load', {
        category: 'ProductPage',
        label: 'Video',
      });
    }
  }, [showVideo]);

  return showVideo ? (
    <VisibilityChecker id="ProductPage-VideoEngagement">
      <Section>
        <Container>
          <Heading>{heading}</Heading>
          <LazyLoad once height="590px">
            <VideoController videoUrl={videoUrl} cover={cover} />
          </LazyLoad>
        </Container>
      </Section>
    </VisibilityChecker>
  ) : null;
};

const Heading = styled(Heading2)`
  text-align: center;
  width: 544px;
  max-width: 100%;
  margin: 0 auto 32px;
  ${media.phone} {
    padding: 0 65px;
  }
`;

const Section = styled.section`
  padding: 0 0 120px;
  ${media.phone} {
    ${Container} {
      padding: 0;
    }
  }
`;
